module.exports = __webpack_public_path__ + "media/images/icons/ico-area-pin-02332a9ec2283fe57e0cd88cca0cb434.svg";